import { render } from "./EmailConfirmationPage.vue?vue&type=template&id=667b9466&ts=true"
import script from "./EmailConfirmationPage.vue?vue&type=script&lang=ts"
export * from "./EmailConfirmationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/EmailConfirmationPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "667b9466"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('667b9466', __exports__)) {
    api.reload('667b9466', __exports__)
  }
  
  module.hot.accept("./EmailConfirmationPage.vue?vue&type=template&id=667b9466&ts=true", () => {
    api.rerender('667b9466', render)
  })

}


export default __exports__